import { httpGet } from "@/api/connection";
import { GetSystemInfoFn } from "./system.types";

const getSystemInfo: GetSystemInfoFn = async (options) => {
  return httpGet("/system/info", {}, options);
};

export const SystemAPI = {
  getSystemInfo,
};
